import React, { useState } from 'react';
import { Box, Container } from '@drivekyte/web-components';
import ServiceAreaModal from '@/components/growth/service-areas/components/service-area-modal';
import WPTypography from '@/components/typography';
import useTranslation, {
  useTranslationAsObject,
} from '@/hooks/use-translation';
import { ServiceAreaDetails } from '@/types/service-area';
import LocalTip from './components/local-tip/local-tip';
import SplitParagraph from './components/split-paragraph';
import TripItem, { TripItemProps } from './components/trip-item/trip-item';

type LocalTipsProps = {
  serviceArea?: ServiceAreaDetails;
};

const LocalTrips = ({ serviceArea }: LocalTipsProps) => {
  const { t } = useTranslation('local-trips');
  const { t: tAsObject } = useTranslationAsObject('local-trips');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const tripList = tAsObject('trips') as [];

  const handleSearchModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <Container>
      <Box paddingVertical="large">
        <LocalTip />
        {tripList.map((trip: TripItemProps, idx: number) => (
          <TripItem
            key={trip.heading}
            index={idx + 1}
            heading={trip.heading}
            distance={trip.distance}
            image={trip.image}
            body={trip.body}
            car={trip.car}
            labels={tAsObject('labels') as TripItemProps['labels']}
            handleSearch={handleSearchModal}
          />
        ))}
        <Box marginVertical="xxxLarge">
          <Box paddingRight="base" marginBottom="xLarge" width="100%">
            <WPTypography
              variant="h2"
              color="primary"
              fontFamily="Gilroy"
              fontSize="28"
              lineHeight={32}
              fontWeight={700}
              textAlign="center"
            >
              {t('conclusion.heading')}
            </WPTypography>
          </Box>

          <SplitParagraph>{t('conclusion.body')}</SplitParagraph>

          {serviceArea && isModalOpen && (
            <ServiceAreaModal
              onRequestToClose={handleSearchModal}
              serviceArea={serviceArea}
            />
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default LocalTrips;
